/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon32Regular = forwardRef('WeatherUmbrellaIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 2a1 1 0 1 0-2 0v2.035C8.284 4.51 2.878 9.72 2.097 16.345 1.99 17.257 2.715 18 3.577 18H15v8a2 2 0 1 1-4 0 1 1 0 1 0-2 0 4 4 0 0 0 8 0v-8h11.423c.862 0 1.588-.744 1.48-1.654C29.123 9.719 23.716 4.509 17 4.036V2ZM4.166 16h23.668C26.883 10.325 21.946 6 16 6S5.117 10.325 4.166 16Z" })));
});
